import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { RestartDialogComponent } from "../restart-dialog/restart-dialog.component";
import { QuestionnaireService } from "../services/questionnaire.service";
import { Router, NavigationEnd } from '@angular/router';
import { HelpDialogComponent } from "../help-dialog/help-dialog.component";
import { LeadService } from "../services/lead.service";
import { ProcessSaveDialogComponent } from '../process-save-dialog/process-save-dialog.component';
import { Draft } from '../services/draft.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class HeaderComponent implements OnInit {
  showContactUs: boolean;
  modalRef;
  @Input() isNewRequest = true;
  @Input() hideLeftButtons = false;
  isCurrentStepFirst$: Observable<boolean>;
  asmachta$: Observable<string>;

  constructor(
    private questionnaireService: QuestionnaireService,
    private draftService: Draft,
    private router: Router,
    private modalService: NgbModal,
    private leadService: LeadService) {

    router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: any) => {
        let path = event.url.split("/");

        this.showContactUs = (path[path.length - 1] !== "end");
      });
  }

  ngOnInit(){
    this.asmachta$ = this.questionnaireService.getAsmachta$();
}

  restartClick() {
    console.log(">>> restartClick()");
    this.draftService.restartDraft();
    this.questionnaireService.openTermsOfUse = true;
    this.draftService.isAfterStep1 = false;
    this.questionnaireService.setAsmachta("");
    this.asmachta$ = this.questionnaireService.getAsmachta$();
    let isAdvisor = this.questionnaireService.getIsAdvisor();
    this.modalRef = this.modalService.open(RestartDialogComponent).result.then((result) => {
      this.leadService.resetGuid();
      
      if (isAdvisor) {
        // this.router.navigate(["questionnaire", "advisors", "1"]);
        this.questionnaireService.reset("0");
      }
      else {
        // this.router.navigate(["questionnaire", "user-details", "1"]);
        this.questionnaireService.reset("1");
      }
      this.router.navigate(["/"]);
      this.questionnaireService.openTermsOfUse = false;
    }, error => {
      this.questionnaireService.openTermsOfUse = false;
    }
    );

  }

  restart(){
    let isAdvisor = this.questionnaireService.getIsAdvisor();
    this.draftService.isAfterStep1 = false;
    this.questionnaireService.setAsmachta("");
    this.asmachta$ = this.questionnaireService.getAsmachta$();
    this.draftService.clearBorrowersArr();
    this.questionnaireService.initData();
    if (isAdvisor) {
      // this.router.navigate(["questionnaire", "advisors", "1"]);
      this.questionnaireService.reset("0");
    }
    else {
      // this.router.navigate(["questionnaire", "user-details", "1"]);
      this.questionnaireService.reset("1");
    }
    this.router.navigate(["/"]);
  }

  openHelpDialog() {
    this.modalRef = this.modalService.open(HelpDialogComponent);
  }

  saveProcess() {
    //this.draftService.updateDraftData$().subscribe(res => console.log(res));
    const modalRef = this.modalService.open(ProcessSaveDialogComponent);
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts